import { render } from "./modal-alert.vue?vue&type=template&id=a24fd530"
import script from "./modal-alert.vue?vue&type=script&lang=js"
export * from "./modal-alert.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__